export class EventLogAttributes {
    constructor(
        public eventType?: string,
        public eventParameter?: string,
        public message?: string
    ) {}
}
